

// import React, { useState, useEffect } from "react";
// import JobWorkerStepsComponent from "./JobWorkerStepsComponent";
// import { Link } from "react-router-dom";

// const JobTypeComponent = ({ onPostJob, user }) => {
//   const [isCollapsibleOpen, setCollapsibleOpen] = useState(false);
//   const [showStandardJobSteps, setShowStandardJobSteps] = useState(false);
//   const [creationMode, setCreationMode] = useState(null); 

//   const [aiInput, setAiInput] = useState("");
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError, setAiError] = useState("");
//   const [aiResult, setAiResult] = useState(null);

//   useEffect(() => {
//     console.log("user from job type component", user);
//   }, [user]);

//   const toggleCollapsible = (event) => {
//     event.preventDefault();
//     setCollapsibleOpen(!isCollapsibleOpen);
//   };

//   if (showStandardJobSteps) {
//     return (
//       <JobWorkerStepsComponent
//         user={user}
//         onGoBackToSearch={() => setShowStandardJobSteps(false)}
//         suburb="ExampleSuburb"
//       />
//     );
//   }

//   const handleSelectManual = () => {
//     setCreationMode("manual");
//   };

//   const handleSelectAI = () => {
//     setCreationMode("ai");
//     if (onPostJob) onPostJob("tasksense");
//   };

//   const handleTaskSenseSubmit = async () => {
//     if (!aiInput.trim()) return;

//     setAiLoading(true);
//     setAiError("");
//     setAiResult(null);

//     try {
//       const primaryLocation =
//         user?.primaryLocation ||
//         user?.suburb ||
//         user?.city ||
//         "";

//       const response = await fetch("/api/tasksense/parse", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           description: aiInput.trim(),
//           primaryLocation,
//         }),
//       });

//       if (!response.ok) {
//         throw new Error(`TaskSense request failed: ${response.status}`);
//       }

//       const data = await response.json();

//       const correctedText =
//         data.correctedText ||
//         data?.jobCraftDetails?.jobDescription ||
//         data?.job?.jobCraftDetails?.jobDescription ||
//         "";

//       const formattedSummary =
//         data.formattedSummary ||
//         data?.job?.formattedSummary ||
//         "";

//       const job =
//         data.job || data;

//       setAiResult({
//         correctedText,
//         formattedSummary,
//         job,
//       });
//     } catch (err) {
//       console.error("TaskSense error", err);
//       setAiError("Something went wrong while generating your job. Please try again.");
//     } finally {
//       setAiLoading(false);
//     }
//   };

//   return (
//     <div
//     className={
//       "job-type-cmpnt-container " +
//       (creationMode === null ? "centered-mode-select" : "")
//     }
//   >

//       <h3 className="cmpnt-subtitle">How would you like to create your job?</h3>

//       <div className="job-creation-mode-toggle">
//         <button
//           type="button"
//           className={`job-mode-btn ${creationMode === "manual" ? "active" : ""}`}
//           onClick={handleSelectManual}
//         >
//           Post Manually
//         </button>

//         <button
//           type="button"
//           className={`job-mode-btn ${creationMode === "ai" ? "active" : ""}`}
//           onClick={handleSelectAI}
//         >
//           Use Our TaskSense AI Assistant
//         </button>
//       </div>

//       {creationMode === "manual" && (
//         <div className="manual-job-container">
//           <div className="job-type-cmpnt-container-grid">
//             <div className="cmpnt-job-type">
//               <h3>Standard</h3>
//               <p>Ongoing or one-off support starting in the next 3 days or more.</p>
//               <Link
//                 to="/account/fs-dashboard/my-jobs/new/standard"
//                 onClick={() => setShowStandardJobSteps(true)}
//                 className="cmpnt-post-job-link"
//               >
//                 Post Standard Job
//               </Link>
//             </div>

//             <div className="cmpnt-job-type">
//               <h3>Last Minute</h3>
//               <p>One-off support starting in the next 4 to 48 hours.</p>
//               <Link
//                 to="/account/fs-dashboard/my-jobs/new/urgent"
//                 onClick={() => setShowStandardJobSteps(true)}
//                 className="cmpnt-post-job-link"
//               >
//                 Post Last Minute Job
//               </Link>
//             </div>
//           </div>

//           <div className="cmpnt-job-comparison">
//             <h4>Compare Job Types</h4>
//             <table>
//               <thead>
//                 <tr>
//                   <th>Standard</th>
//                   <th>Last Minute</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Worker response time: 24 hours</td>
//                   <td>2 hours</td>
//                 </tr>
//                 <tr>
//                   <td>Job post expiry: 30 days</td>
//                   <td>2 days max</td>
//                 </tr>
//                 <tr>
//                   <td>Search and invite worker: Yes</td>
//                   <td>No</td>
//                 </tr>
//                 <tr>
//                   <td>Max worker offers: No limit</td>
//                   <td>5</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </div>
//       )}

//       {creationMode === "ai" && (
//         <div className="tasksense-mode-panel">
//           <h3>TaskSense AI Job Crafting</h3>
//           <p>
//             Describe your needs in one or two sentences and let our <strong>TaskSense AI Assistant</strong> turn it
//             into a clear, well-structured job post. You can still review and edit before posting.
//           </p>

//           <ul className="tasksense-benefits-list">
//             <li>Type a simple sentence in your own words.</li>
//             <li><strong>TaskSense</strong> crafts it into a job title, description, and key details.</li>
//             <li>Faster job creation with fewer steps.</li>
//           </ul>

//           <div className="tasksense-input-wrapper">
//             <textarea
//               className="tasksense-input"
//               rows={3}
//               placeholder="E.g. I'm looking for someone to help remove snow from my backyard tomorrow morning. I can pay $20/hr for about 2 hours."
//               value={aiInput}
//               onChange={(e) => setAiInput(e.target.value)}
//             />
//             <div className="tasksense-actions">
//               <button
//                 type="button"
//                 className="tasksense-generate-btn"
//                 onClick={handleTaskSenseSubmit}
//                 disabled={aiLoading || !aiInput.trim()}
//               >
//                 {aiLoading ? "Crafting your job..." : "Generate with TaskSense"}
//               </button>
//             </div>
//             {aiError && <p className="tasksense-error-text">{aiError}</p>}
//           </div>

//           {aiResult && (
//             <div className="tasksense-result">
//               <h4>Corrected Description</h4>
//               <p>{aiResult.correctedText}</p>

//               {aiResult.formattedSummary && (
//                 <>
//                   <h4>Job Summary</h4>
//                   <p>{aiResult.formattedSummary}</p>
//                 </>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//     </div>
//   );
// };

// export default JobTypeComponent;

import React, { useState, useEffect } from "react";
import JobWorkerStepsComponent from "./JobWorkerStepsComponent";
import { Link, useNavigate } from "react-router-dom";
import { useTaskSense } from "../../../context/TaskSenseContext";

const JobTypeComponent = ({ onPostJob, user }) => {
  const navigate = useNavigate();

  const [isCollapsibleOpen, setCollapsibleOpen] = useState(false);
  const [showStandardJobSteps, setShowStandardJobSteps] = useState(false);
  const [creationMode, setCreationMode] = useState(null);

  const [showReviewFromTaskSense, setShowReviewFromTaskSense] = useState(false);

  const { isCrafting, error: taskSenseError, craftJobFromPrompt } = useTaskSense();
  const [aiInput, setAiInput] = useState("");
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState("");
  const [aiResult, setAiResult] = useState(null);

  useEffect(() => {
    console.log("user from job type component", user);
  }, [user]);

  const toggleCollapsible = (event) => {
    event.preventDefault();
    setCollapsibleOpen(!isCollapsibleOpen);
  };

  if (showStandardJobSteps) {
    return (
      <JobWorkerStepsComponent
        user={user}
        onGoBackToSearch={() => setShowStandardJobSteps(false)}
        suburb="ExampleSuburb"
      />
    );
  }

  // const handleSelectManual = () => {
  //   setCreationMode("manual");
  // };

  // const handleSelectAI = () => {
  //   setCreationMode("ai");
  //   if (onPostJob) onPostJob("tasksense");
  // };

   const goManual = () => {
    navigate("/account/fs-dashboard/my-jobs/new/standard", {
      state: { jobCreationMode: "manual" },
    });
  };

  const goTaskSense = () => {
    navigate("/account/fs-dashboard/my-jobs/new/standard", {
      state: { jobCreationMode: "tasksense" },
    });
  };

  const handleTaskSenseSubmit = async () => {
    if (!aiInput.trim()) return;

    setAiError("");

    try {
      const primaryLocation =
        user?.primaryLocation || user?.suburb || user?.city || "";

      const res = await craftJobFromPrompt(aiInput.trim(), primaryLocation);

      console.log("[TaskSense UI] crafted:", res);

      navigate("/account/fs-dashboard/my-jobs/new/standard/step-6", {
        state: { fromTaskSense: true },
      });
    } catch (err) {
      console.error("[TaskSense UI] error:", err);
      setAiError(err?.message || "Failed to craft job");
    }
  };


  const handleProceedToReview = () => {
    setShowReviewFromTaskSense(true);
  };


  const isLoading = isCrafting;

  return (
    <div
      className={
        "job-type-cmpnt-container " +
        (creationMode === null ? "centered-mode-select" : "")
      }
    >
      <p className="cmpnt-subtitle">
        How would you like to create your job?
      </p>

      <div className="job-creation-mode-toggle">

        <button className="cmpnt-post-job-link" onClick={goManual}>Post Manually</button>

        <Link
          to="/account/fs-dashboard/my-jobs/new/standard"
          state={{ jobCreationMode: "tasksense" }}
          className="cmpnt-post-job-link"
        >
          Use Our TaskSense AI Assistant
        </Link>
      </div>

      {/* Manual job container (hidden until Manual selected) */}
      {creationMode === "manual" && (
        <div className="manual-job-container">
          <div className="job-type-cmpnt-container-grid">
            <div className="cmpnt-job-type">
              <h3>Standard</h3>
              <p>Ongoing or one-off support starting in the next 3 days or more.</p>
              <Link
                to="/account/fs-dashboard/my-jobs/new/standard"
                onClick={() => setShowStandardJobSteps(true)}
                className="cmpnt-post-job-link"
              >
                Post Standard Job
              </Link>
            </div>

            <div className="cmpnt-job-type">
              <h3>Last Minute</h3>
              <p>One-off support starting in the next 4 to 48 hours.</p>
              <Link
                to="/account/fs-dashboard/my-jobs/new/urgent"
                onClick={() => setShowStandardJobSteps(true)}
                className="cmpnt-post-job-link"
              >
                Post Last Minute Job
              </Link>
            </div>
          </div>

          <div className="cmpnt-job-comparison">
            <h4>Compare Job Types</h4>
            <table>
              <thead>
                <tr>
                  <th>Standard</th>
                  <th>Last Minute</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Worker response time: 24 hours</td>
                  <td>2 hours</td>
                </tr>
                <tr>
                  <td>Job post expiry: 30 days</td>
                  <td>2 days max</td>
                </tr>
                <tr>
                  <td>Search and invite worker: Yes</td>
                  <td>No</td>
                </tr>
                <tr>
                  <td>Max worker offers: No limit</td>
                  <td>5</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}


    </div>
  );
};

export default JobTypeComponent;



